import { render, staticRenderFns } from "./helpJump.vue?vue&type=template&id=31ba7e24&"
import script from "./helpJump.vue?vue&type=script&lang=js&"
export * from "./helpJump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports